module.exports = __webpack_public_path__ + "img/img-2-desk.2a8f648b.jpg";